import createLink from '@anm/helpers/createLink';

const getCsvCell = (value: string) => `${value}`;

const makeRow = (row: string[]) =>
  row.reduce((rowAcc, cell, index) => {
    const isLastCell = row.length - 1 === index;
    const newData = `${rowAcc} ${getCsvCell(cell)}`;

    return !rowAcc
      ? `${getCsvCell(cell)},`
      : isLastCell
      ? `${newData}\n`
      : `${newData},`;
  }, '');

const makeTable = (table: string[][]) =>
  table.reduce((tableAcc, row) => {
    const rowStr = makeRow(row);

    return `${tableAcc}${rowStr}`;
  }, '');

const useDownloadCSV = (data: string[][][], fileName = 'downloaded.csv') => {
  const csvContentStart = 'data:text/csv;charset=utf-8,';

  const dataCsv = data.reduce((acc, tableData) => {
    const tableStr = makeTable(tableData);

    return `${acc}${tableStr}\n`;
  }, csvContentStart);

  const [link, cleanLink] = createLink(dataCsv);
  link.setAttribute('download', fileName);

  return () => {
    link.click();
    cleanLink();
  };
};

export default useDownloadCSV;
